/**
 * SkipLink — first focusable element on every page.
 * Hidden until focused; jumps the user (and screen readers) past the
 * navigation directly into the page's <main id="main"> landmark.
 *
 * WCAG 2.1 Success Criterion 2.4.1 (Bypass Blocks).
 */
export function SkipLink() {
  return (
    <a
      href="#main"
      className="
        sr-only
        focus:not-sr-only
        focus:fixed focus:top-3 focus:left-3 focus:z-[100]
        focus:px-4 focus:py-2.5 focus:rounded-full
        focus:bg-brand-600 focus:text-white focus:font-semibold focus:text-sm
        focus:shadow-glow
        focus:outline-none focus:ring-2 focus:ring-brand-300 focus:ring-offset-2
        focus:ring-offset-surface dark:focus:ring-offset-ink-950
      "
    >
      Skip to main content
    </a>
  );
}
